import { UserCheck } from "lucide-react";

export const UserListHeader = () => {
  return (
    <div className="flex justify-between items-center mb-8 px-4 md:px-6 lg:px-8">
      <div>
        <h1 className="text-3xl font-bold">User Management</h1>
        <p className="text-muted-foreground mt-1">Manage and monitor user accounts</p>
      </div>
      <UserCheck className="h-8 w-8 text-primary hidden md:block" />
    </div>
  );
};